import type { DocumentGroup } from '../utils/grouping'
import type { DocumentRow } from '../api/types'
import { DocumentCard } from './DocumentCard'

export interface DocumentGridProps {
  groups: DocumentGroup[]
  selectedId: number | null
  onSelect: (row: DocumentRow) => void
}

export function DocumentGrid({ groups, selectedId, onSelect }: DocumentGridProps) {
  return (
    <div className="flex flex-col gap-5">
      {groups.map((group) => (
        <section key={group.key} className="flex flex-col gap-2">
          {group.label ? (
            <header className="text-role-section-label flex items-center gap-2">
              <span>{group.label}</span>
              <span className="rounded-full bg-muted px-2 py-0.5 text-2xs normal-case text-secondary">
                {group.items.length}
              </span>
            </header>
          ) : null}
          <div
            role="list"
            className="flex flex-wrap gap-3"
            aria-label={group.label || 'Documents'}
          >
            {group.items.map((row) => (
              <div role="listitem" key={row.lot_id}>
                <DocumentCard
                  row={row}
                  selected={selectedId === row.lot_id}
                  onClick={onSelect}
                />
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  )
}
